export const MODULE_TITLES = {
  primary_media: 'Cover',
  hero_media: 'Cover',
  media_card: 'Memory',
  text: 'Letter',
  surprise_box: 'Open When',
  flip_card: 'Reveal',
  tiny_museum: 'Tiny Museum',
  voice_postcard: 'Voice',
  memory_map: 'Memory Map',
  then_now: 'Then & Now',
  frame_gallery: 'Frame',
  timeline: 'Timeline',
  polaroid_booth: 'Booth',
  reaction: 'Reply',
  guestbook: 'Blessing Wall',
  keepsake_poster: 'Final Card',
  song_dedication: 'Song',
  wisdom: 'Wisdom',
};

export const getModuleTitle = (module, index) => (
  module?.data?.title || module?.data?.label || MODULE_TITLES[module?.type] || `Moment ${index + 1}`
);

export const EXPERIENCE_LINES = [
  'Start here',
  'A little piece saved for you',
  'Something personal',
  'A memory worth opening',
  'One more surprise',
  'Almost at the final note',
  'The last little keepsake',
];

export const getExperienceLine = (index) => (
  EXPERIENCE_LINES[Math.min(index, EXPERIENCE_LINES.length - 1)]
);

export const getProgressPercent = (index, total) => {
  if (!total) return 0;
  return Math.min(100, Math.max(0, Math.round(((index + 1) / total) * 100)));
};

export const nudge = (pattern = 25) => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};

export const playSoftTone = (frequency = 660, duration = 0.12) => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const audioContext = new AudioContext();
    const oscillator = audioContext.createOscillator();
    const gain = audioContext.createGain();
    oscillator.frequency.value = frequency;
    oscillator.type = 'sine';
    gain.gain.setValueAtTime(0.0001, audioContext.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.07, audioContext.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, audioContext.currentTime + duration);
    oscillator.connect(gain);
    gain.connect(audioContext.destination);
    oscillator.start();
    oscillator.stop(audioContext.currentTime + duration + 0.02);
    setTimeout(() => audioContext.close(), (duration + 0.08) * 1000);
  } catch {
    // Audio is decorative only.
  }
};
